import Invoicing from '@pages/Invoicing.vue'

const permissions = [
  {
    role: 'Guest',
    access: false,
    redirect: 'Home'
  },
  {
    role: 'Member',
    access: false,
    redirect: 'Dashboard'
  },
  {
    role: 'Company',
    access: false,
    redirect: 'Dashboard'
  }
]

export default [
  {
    path: '/invoicing',
    name: 'Invoicing',
    component: Invoicing,
    meta: {
      // Enforced by the vue-router-user-roles library (see main.js): a
      // non-superuser (Member/Company/Guest) is denied and redirected to
      // the Dashboard. The access-denied toast is shown by the Dashboard,
      // flagged via sessionStorage in router.js beforeEach.
      permissions: permissions
    }
  }
]
